import { useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../../helpers/httpWrapper';
import {
	IConfigureHubCommunityRequest,
	IConfigureHubCommunityResponse,
	VConfigureHubCommunity,
} from '../../../../../networked-shared-interfaces/interfaces-phase2/platform-admin/sub-routes/community';
import { URLWrapper } from '../../../../../networked-shared-interfaces/url-wrapper';
import { toastService } from '../../../../../services/toast.service';

interface IConfigureHubCommunityState {
	loading: boolean;
	error: string | null;
	result: IConfigureHubCommunityResponse | null;
}

export const useConfigureHubCommunity = () => {
	const [state, setState] = useState<IConfigureHubCommunityState>({
		loading: false,
		error: null,
		result: null,
	});

	const configureHubCommunity = async (communityId: string): Promise<IConfigureHubCommunityResponse | null> => {
		setState({ loading: true, error: null, result: null });

		try {
			const body: IConfigureHubCommunityRequest = { communityId };

			const res = await HttpWrapper.callUrl<IConfigureHubCommunityRequest, IConfigureHubCommunityResponse>(
				URLWrapper.urls.platformAdmin.configureHubCommunity,
				HttpMethod.POST,
				body,
				VConfigureHubCommunity
			);

			setState({ loading: false, error: null, result: res });
			toastService.success('Community converted to Networked Hub successfully!');
			return res;
		} catch (err: any) {
			const message = err?.message || 'Failed to convert community to Networked Hub.';
			setState({ loading: false, error: message, result: null });
			toastService.error(message);
			return null;
		}
	};

	return { ...state, configureHubCommunity };
};
